<template>
    <div>
      <h2>Parking Fee After Discount</h2>
      <p>Your remaining fee is: {{ remainingFee }}</p>
    </div>
  </template>
  
  <script>
  export default {
    props: ['remainingFee']
  };
  </script>
  
  <style scoped>
  h2 {
    margin: 20px 0;
  }
  p {
    margin-bottom: 10px;
    color: #333;
  }
  </style>
  